import { ManifestValidationException } from "../../exceptions/manifest-validation-exception";
import { Microservice } from "../../model/microservice";
import { BaseChainableBobComponent } from "../base-chainable-bob-component";
import { IProcessable } from "../pipeline/processable.interface";

export class ManifestValidatorComponent extends BaseChainableBobComponent<Microservice> implements IProcessable<Microservice> {

	/**
	 * Starts with the validation of the object passed along.
	 *
	 * @param input
	 */

	public async process(input: Microservice) {

		this.validateProperties(input);

		return await this.next.process(input);
	}

	/**
	 * Validates for the required manifest properties ("name" and "html").
	 *
	 * @param input
	 */

	private validateProperties(input: Microservice): void {

		const manifest = input.manifest;

		if (!manifest.hasOwnProperty("name") || manifest.name.trim().length === 0) {

			this.tracker.trackEvent({
				url: input.marker.url,
				category: "Microservice",
				action: "RequestFailed",
				label: "NoName"
			});

			this.throwException("name");
		}

		if (!manifest.hasOwnProperty("html") || manifest.html.trim().length === 0) {

			this.tracker.trackEvent({
				url: input.marker.url,
				category: "Microservice",
				action: "RequestFailed",
				label: "NoHtml"
			});

			this.throwException("html");
		}
	}

	/**
	 * Throws a custom exception to stop the current pipeline.
	 *
	 * @param type
	 */

	private throwException(type: string): any {

		throw new ManifestValidationException(type);
	}
}
